/* eslint-disable no-redeclare */
import { Integer } from '@hc-frontend/core-types';
import { z } from 'zod';

export const SearchPartnerTcpaRequest = z.object({
  partnerId: z.string().optional(),
  productTypeId: z.string().optional(),
});

export type SearchPartnerTcpaRequest = z.infer<typeof SearchPartnerTcpaRequest>;

export const PartnerConfigurationDto = z.object({
  partnerId: Integer,
  configurationName: z.string(),
  configurationValue: z.string(),
});

export type PartnerConfigurationDto = z.infer<typeof PartnerConfigurationDto>;

export const SearchPartnerTcpaResponse = PartnerConfigurationDto.array();

export type SearchPartnerTcpaResponse = z.infer<
  typeof SearchPartnerTcpaResponse
>;

export const FetchPartnerConfigurationsRequest = z.object({
  partnerId: z.string().optional(),
  productTypeId: z.string().optional(),
  configurationName: z.string().optional(),
  configurationValue: z.string().optional(),
});

export type FetchPartnerConfigurationsRequest = z.infer<
  typeof FetchPartnerConfigurationsRequest
>;

export const FetchPartnerConfigurationsResponse =
  PartnerConfigurationDto.array();

export type FetchPartnerConfigurationsResponse = z.infer<
  typeof FetchPartnerConfigurationsResponse
>;

export const FetchPartnerConfigurationsByIdRequest = z.object({
  partnerId: z.string().optional(),
});

export type FetchPartnerConfigurationsByIdRequest = z.infer<
  typeof FetchPartnerConfigurationsRequest
>;

export const FetchPartnerConfigurationsByIdResponse =
  FetchPartnerConfigurationsResponse;

export type FetchPartnerConfigurationsByIdResponse = z.infer<
  typeof FetchPartnerConfigurationsByIdResponse
>;
